import { GetPropertiesGetRequestParams } from "commonModule/services/common"

export type SortByType =
  | "recommended"
  | "highToLow"
  | "lowToHigh"
  | "highToLowGuest"
  | "lowToHighGuest"
  | "bestDeals"
  | "biggestSavings"
  | "guestRatings"

export enum SearchType {
  withPolygon = "withPolygon",
  withoutPolygon = "withoutPolygon",
  nearByProperties = "nearByProperties",
}
export type SearchApiRequestType =
  | SearchType.withPolygon
  | SearchType.withoutPolygon
  | SearchType.nearByProperties
  | ""

export type SearchInitialState = {
  state: {
    adultCount?: number
    bounds: null | string
    childrenCount?: number
    currentUpdatedURL: string
    endDate: string | null
    isSearchingInMap?: boolean
    isBoundaryVisible?: boolean
    lat?: number | null
    limit?: number
    lng?: number | null
    shortName: string | null
    noOfDays: number
    page?: number
    petAllowed?: boolean
    longName?: string | null
    placeId: string | null
    placeType?: string | null
    startDate: string | null
    sortBy: SortByType
    toggleOn: boolean
    propertyConfigTypeId: number | null
    childAllowed?: boolean
    suitableChild?: boolean
    eventAllowed?: boolean
    FeaturesAndAmenities?: number[]
    Location?: number[]
    propertyTypeDesc?: string[]

    numberOfBathroom?: number
    numberOfBedroom?: number
    minBed?: number
    numberOfGuest?: number | null
    maxprice?: number
    minPrice?: number
    smokeAllowed?: boolean
    suitableInfant?: boolean

    features?: string[]

    nearByProperties?: boolean
    isBoundaryAutoRemoved?: boolean

    apiRequestType: SearchApiRequestType

    cancellable?: boolean

    showClearFilterButton?: boolean
    clickClearFilter?: boolean
    allowSameDay?: boolean
    expandedMiles?: number | null
  }

  searchQuery: GetPropertiesGetRequestParams | null
}
